<span class="copyright">&copy; 2015 - {{ currentYear }} <a [href]="appInfo.providerUrl" target="_blank" rel="noopener">{{ appInfo.provider }}</a></span>
